var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinnedNoteInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/info-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/info-circle_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.50033 10.0846C8.02116 10.0846 10.0837 8.02214 10.0837 5.5013C10.0837 2.98047 8.02116 0.917969 5.50033 0.917969C2.97949 0.917969 0.916992 2.98047 0.916992 5.5013C0.916992 8.02214 2.97949 10.0846 5.50033 10.0846Z",
    stroke: "#326CFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.5 3.66797V5.95964",
    stroke: "#326CFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.49707 7.33203H5.50119",
    stroke: "#326CFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedNoteInfoIcon);
export default __webpack_public_path__ + "static/media/pinned_note_info_icon.9627d25bcde9ec7a93b744ca69f3aaa0.svg";
export { ForwardRef as ReactComponent };